import React from 'react';
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import { FiCheck } from "react-icons/fi";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ContactOne from "../elements/contact/ContactOne";
import ScrollAnimation from "react-animate-on-scroll";


const VpsSol = () => {
    return (
        <>
            <SEO title="Services" />
            <Layout>
                <BreadcrumbOne 
                    title="VPS Solutions"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="VPS Solutions"
                />
            <div className="main-content">
            
        <div className="rn-splite-style bg-color-blackest">
            <div className="split-wrapper">
                <div className="row no-gutters radius-10 align-items-center">
                    <div className="order-2 order-lg-1 col-lg-12 col-xl-6 col-12">
                        <div className="split-inner">
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">Virtual Private Servers will empower the customers to run their applications perfectly for rapidly growing web based business with full root access and highly customizable options. Guaranteed availability and reliability will be key feature of the VPS solutions provided by us.</p>
                            </ScrollAnimation>
                        </div>
                    </div>
                    <div className="order-1 order-lg-2 col-lg-12 col-xl-6 col-12">
                        <div className="thumbnail">
                            <img src="./images/portfolio/vps.jpeg" alt="hosting" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
        </Layout>
        </>
    )
}
export default VpsSol;